import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { Icon } from '../../Icon';
import { StyledInputNumberController, StyledInputNumberControllers, } from './InputNumberControllers.style';
export const InputNumberControllers = ({ inputRef, disabled, }) => {
    const theme = useTheme();
    const [isControllersVisible, setIsControllersVisible] = useState(false);
    const onControllerClick = (modifier) => {
        const input = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
        if (!input)
            return;
        if (modifier === 'increase') {
            input.stepUp();
        }
        else {
            input.stepDown();
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const handleMouseEnter = useCallback(() => setIsControllersVisible(true), [setIsControllersVisible]);
    const handleMouseLeave = useCallback(() => setIsControllersVisible(false), [setIsControllersVisible]);
    useEffect(() => {
        const input = inputRef.current;
        const inputWrapper = input === null || input === void 0 ? void 0 : input.parentNode;
        if (inputWrapper) {
            inputWrapper.addEventListener('mouseenter', handleMouseEnter);
            inputWrapper.addEventListener('mouseleave', handleMouseLeave);
        }
        return () => {
            if (inputWrapper) {
                inputWrapper.removeEventListener('mouseenter', handleMouseEnter);
                inputWrapper.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [handleMouseEnter, handleMouseLeave, inputRef]);
    return (_jsxs(StyledInputNumberControllers, { visible: isControllersVisible, children: [_jsx(StyledInputNumberController, { type: "button", disabled: disabled, onClick: () => onControllerClick('increase'), children: _jsx(Icon, { name: "chevron---up", size: "XSmall", color: theme.Color.Neutrals.Dark }) }), _jsx(StyledInputNumberController, { type: "button", disabled: disabled, onClick: () => onControllerClick('decrease'), children: _jsx(Icon, { name: "chevron---down", size: "XSmall", color: theme.Color.Neutrals.Dark }) })] }));
};
//# sourceMappingURL=InputNumberControllers.js.map